import { render, staticRenderFns } from "./DPMCard.vue?vue&type=template&id=d2cb9f52&scoped=true"
import script from "./DPMCard.vue?vue&type=script&lang=js"
export * from "./DPMCard.vue?vue&type=script&lang=js"
import style0 from "./DPMCard.vue?vue&type=style&index=0&id=d2cb9f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cb9f52",
  null
  
)

export default component.exports